import {createAsyncThunk} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import instance from '@/config/axios'

export const getRefundCustomerDetail = createAsyncThunk('refund/getRefundCustomerDetail',
  async (payload: any) => {
    try {
      const url = `/v1/refunds/${payload.refundId}/customer`
      const response: AxiosResponse<Refund> = await instance.get(url,{
        headers: {
          Authorization: `Bearer ${payload.token}`
        }
      })
      return response.data
    } catch (e) {
      payload.fail()
      return null
    }
  })

export const submitRefundCustomerDetail = createAsyncThunk('refund/submitRefundCustomerDetail',
  async (payload: any) => {
    const url = `/v1/refunds/${payload.refundId}/customer/info`
    try {
      const response: AxiosResponse<Refund> = await instance.post(
        url,
        payload.body,
        {
          headers: {
            Authorization: `Bearer ${payload.token}`
          }
        })
      payload.success()
      return response.data
    } catch (e) {
      payload.fail()
      return null
    }
  })

